import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

interface FilePreviewModalProps {
  isOpen: boolean;
  toggle: () => void;
  fileUrl: string;
  fileType: string;
  fileName: string;
}

const FilePreviewModal: React.FC<FilePreviewModalProps> = ({ isOpen, toggle, fileUrl, fileType, fileName }) => {
  const isImage = /^image\//.test(fileType);
  const isPdf = fileType === 'application/pdf';

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" centered className="file-preview-modal">
      <ModalHeader toggle={toggle}>{fileName}</ModalHeader>
      <ModalBody style={{ height: '80vh', overflow: 'hidden', padding: 0 }}>
        {fileUrl ? (
          <>
            {isImage ? (
              <div className="d-flex justify-content-center align-items-center h-100 p-2">
                <img src={fileUrl} alt={fileName} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
              </div>
            ) : isPdf ? (
              <iframe src={fileUrl} title={fileName} width="100%" height="100%" style={{ border: 'none' }} />
            ) : (
              <div className="d-flex flex-column justify-content-center align-items-center h-100">
                <p className="mb-3">Preview not available for this file type ({fileType}).</p>
                <Button color="primary" href={fileUrl} target="_blank" rel="noopener noreferrer">
                  Open in New Tab
                </Button>
              </div>
            )}
          </>
        ) : (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Close</Button>
      </ModalFooter>
    </Modal>
  );
};

export default FilePreviewModal;
